// extracted by mini-css-extract-plugin
module.exports = {"boxBreadcrumb":"_2GpPHfxrpmA_xn0WIZERd7","breadcrumb":"_3_f51OwW2lg70EKEZNnba7","label":"_3iwjAKkwnMPUHTAy6L8dLp"};